import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {OperationAdminDto} from '../model/operation-admin-dto';
import {TypeOperationAdminDto} from '../model/type-operation-admin.dto';

@Injectable({
	providedIn: 'root'
})
export class OperationsAdminService {
	private url = '/ws/operations-admin';

	constructor(private http: HttpClient) {
	}

	listerTypesOperationAdmin(): Observable<TypeOperationAdminDto[]> {
		return this.http.get<TypeOperationAdminDto[]>(this.url, {});
	}

	executerOperation(operationAdminDto: OperationAdminDto): Observable<void> {
		return this.http.post<void>(this.url, operationAdminDto);
	}
}
